export const pedestrianCircuitsData = {
  title: "Pěší - okruhy",
  introduction:
    "Trasy jsou pouze doporučené a účastníci si je mohou dle potřeb upravit. Každý se účastní na vlastní riziko.",
  downloadMapsComment: "Všechny trasy ke stažení.",
  downloadMapLink: "Odkaz na mapy.cz",
  mapsPath: "https://mapy.cz/s/ladovasete",
  routeDetails: [
    {
      subtitle: "Trasa C - 26 km",
      routeDescription:
        "Hlučín - Děhylov - Bobrovníky - Hornické muzeum Landek (kontrola 3) - Bažantnice Šiheřovice - Darkovičky (kontrola 4) - Hlučín",
      path: "https://mapy.cz/s/lutelocago",
      src: "/images/routes/trasa-C.png",
    },
    {
      subtitle: "Trasa D - 35 km",
      routeDescription:
        "Hlučín - Děhylov - Bobrovníky - rozhledna Hošťálkovice - Hornické muzeum Landek (kontrola 3) - Bažantnice Šiheřovice - zámek Šilheřovice - Darkovičky (kontrola 4) - Hlučín",
      path: "https://mapy.cz/s/bebedurusu",
      src: "/images/routes/trasa-D.png",
    },
    {
      subtitle: "Trasa D1 - 42 km",
      routeDescription:
        "Hlučín - Děhylov - Bobrovníky - rozhledna Hošťálkovice - Hornické muzeum Landek (kontrola 3) - Koblov - Antošovice - Bažantnice Šiheřovice - zámek Šilheřovice - Darkovičky (kontrola 4) - Hlučín",
      path: "https://mapy.cz/s/nelehusegu",
      src: "/images/routes/trasa-D1.png",
    },
    {
      subtitle: "Velký okruh I - 60 km",
      routeDescription:
        "Hlučín - Darkovičky (kontrola 4) - Bolatice (kontrola 6) - Kravaře - Hrabyně (kontrola 1) - Háj ve Slezsku - Dobroslavice (kontrola 2) - Hlučín",
      path: "https://mapy.cz/s/humojupelu",
      src: "/images/routes/velky-okruh-I.png",
    },
  ],
};
